import { ID } from 'app/components/Table/core/types';
import { TippyDefault } from 'app/components/Tippy';

import { TimeframeExport } from 'app/modules/reporting/components/TimeframeExport';
import { downloadTrasactionLedger } from 'app/modules/system-settings/devices/core/requests';

import { useBoolean } from 'app/hooks';

const ExportLedger = ({ sensorId, onCloseMenu }: { sensorId: ID; onCloseMenu?: () => void }) => {
  const isOpen = useBoolean(false);
  const isLoading = useBoolean(false);

  const handleClose = () => isOpen.setValue(false);
  const handleOpen = () => isOpen.setValue(true);

  const handleExport = async (filter: { fromDate: Date; toDate: Date }) => {
    const { fromDate, toDate } = filter;

    const from = new Date(
      Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate()),
    );
    const to = new Date(
      Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), 23, 59, 59, 999),
    );

    try {
      isLoading.setValue(true);
      await downloadTrasactionLedger({
        sensorId,
        from: from.getTime().toString(),
        to: to.getTime().toString(),
      });
    } finally {
      isLoading.setValue(false);
      isOpen.setValue(false);
      onCloseMenu?.();
    }
  };

  return (
    <>
      <span onClick={handleOpen}>Export Ledger</span>
      <TippyDefault
        containerClass="action-menu"
        placement="bottom-start"
        offset={[0, 10]}
        interactive
        arrow={false}
        trigger="click"
        visible={isOpen.value}
        onClickOutside={handleClose}
        allowHTML
        content={
          isOpen.value && (
            <TimeframeExport
              onExport={handleExport}
              onClose={handleClose}
              isSubmitting={isLoading.value}
              title="Export transaction"
            />
          )
        }
      >
        <span className="hidden"></span>
      </TippyDefault>
    </>
  );
};

export default ExportLedger;
